import { checkLoginByCodeApi } from '../../api';
import { useEffect, useState } from 'react';

export default function useCheckLoginByCode(code: string) {
  const [_code, setCode] = useState<string>(code);
  useEffect(() => {
    if (_code != code) {
      setCode(code);
    }
  }, [code]);
  const [data, setData] = useState<any>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const checkLogin = async () => {
    console.log('useCheckLoginByCode', { isLoading, code: _code });
    if (isLoading) return;
    if (_code) {
      setIsLoading(true);
      try {
        const res = await checkLoginByCodeApi(_code).finally(() =>
          setIsLoading(false)
        );

        setData(JSON.parse(atob(res.result)));
      } catch (err) {
        console.error('checkLogin error', err);
        setData(null);
        setTimeout(() => {
          checkLogin();
        }, 3000);
      }
    }
  };
  useEffect(() => {
    checkLogin();
  }, [_code]);
  return {
    data,
    isLoading,
  };
}
